import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as homepageSlice from "../../../../redux/slices/homepageSlice";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { Trash } from "@phosphor-icons/react";
import DeleteModal from "../../components/DeleteModal";
import { imageBaseUrl } from "../../../../helper";

const CustomerShared = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletableId, setDeletableId] = useState(null);
  const dispatch = useDispatch();
  
  const { customerSharedImages, loading } = useSelector((state) => state.homepageSlice);

  // Handle file selection
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedFile) {
      toast("Please select an image.");
      return;
    }

    const formData = new FormData();
    formData.append("scroller_image", selectedFile);

    await dispatch(homepageSlice.storeCustomerSharedImages(formData));
    dispatch(homepageSlice.getCustomerSharedImages());

    setSelectedFile(null);
    event.target.reset();
  };

  // Handle delete
  const handleDelete = (imageId) => {
    setDeleteModal(true);
    setDeletableId(imageId);
  };

  const handleDeleteImage = () => {
    dispatch(homepageSlice.deleteCustomerSharedImage(deletableId)).then(() => {
      dispatch(homepageSlice.getCustomerSharedImages());
      setDeleteModal(false);
    });
  };

  useEffect(() => {
    dispatch(homepageSlice.getCustomerSharedImages());
  }, [dispatch]);

  // DataTable Columns with Delete Action only
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "Image",
      selector: (row) => <img src={`${imageBaseUrl}${row?.image}`} style={{ width: "50px", height: "50px" }} />,
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex">
          <div className="delete">
            <Trash onClick={() => handleDelete(row.id)} size={19} />
          </div>
        </div>
      ),
    },
  ];
  console.log(customerSharedImages,"data")
  return (
    <>
      <h5 className="mb-4"> Customer Shared Images</h5>
      <Row className="mt-4">
        <Col md={12} className="mb-4">
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>Select Image</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleFileChange}
              />
            </Form.Group>
            <Button variant="primary" style={{ backgroundColor: '#e8783d', borderColor: '#e8783d' }} type="submit">
              Save Image
            </Button>
          </Form>
        </Col>
      </Row>

      {/* DataTable for displaying customer shared images */}
      <h6 className="mb-4">Added Images:</h6>
      {loading ? (
        <div className="w-100 d-flex">
          <div className="spinner-border text-primary mx-auto" role="status"></div>
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={customerSharedImages?.scroller_images || []}
          pagination
          highlightOnHover
          pointerOnHover
        />
      )}

      {/* Delete Confirmation Modal */}
      <DeleteModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} handleDelete={handleDeleteImage} name={"Image"} />
    </>
  );
};

export default CustomerShared;
